import { Spinner } from 'components/Elements';
import { MainLayout } from 'components/Layout';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const { Dashboard } = lazyImport(() => import('features/misc'), 'Dashboard');
const { Profile } = lazyImport(() => import('features/users'), 'Profile');
const { AccountsRoutes } = lazyImport(() => import('features/accounts'), 'AccountsRoutes');
const { BusinessesRoutes } = lazyImport(() => import('features/businesses'), 'BusinessesRoutes');
const { SettingsRoutes } = lazyImport(() => import('features/settings'), 'SettingsRoutes');
const { RidersRoutes } = lazyImport(() => import('features/riders'), 'RidersRoutes');
const { MessagingRoutes } = lazyImport(() => import('features/messaging'), 'MessagingRoutes');
const { PostsRoutes } = lazyImport(() => import('features/posts'), 'PostsRoutes');
const { PlacesRoutes } = lazyImport(() => import('features/places'), 'PlacesRoutes');
const { NotificationsRoutes } = lazyImport(
  () => import('features/notifications'),
  'NotificationsRoutes'
);

const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/my-account', element: <Profile /> },
      { path: '/app/accounts/*', element: <AccountsRoutes /> },
      { path: '/app/posts/*', element: <PostsRoutes /> },
      { path: '/app/places/*', element: <PlacesRoutes /> },
      { path: '/app/conversations/*', element: <MessagingRoutes /> },
      { path: '/app/businesses/*', element: <BusinessesRoutes /> },
      { path: '/app/notifications/*', element: <NotificationsRoutes /> },
      { path: '/app/settings/*', element: <SettingsRoutes /> },
      { path: '/app/riders/*', element: <RidersRoutes /> },
      { path: '/app/', element: <Dashboard /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
